import { Navigate, Route, Routes } from 'react-router-dom'
import { useSession } from './lib/session'
import { AppShell } from './components/AppShell'
import { Loading } from './components/ui'
import { Welcome } from './routes/Welcome'
import { SignUp } from './routes/SignUp'
import { SignIn } from './routes/SignIn'
import { Join } from './routes/Join'
import { ForgotPassword, ResetPassword } from './routes/Password'
import { Today } from './routes/Today'
import { Week } from './routes/Week'
import { Family } from './routes/Family'
import { Plans } from './routes/Plans'
import { Agreement } from './routes/Agreement'
import { Settings } from './routes/Settings'

export function App() {
  const { state } = useSession()

  if (state === 'loading') return <Loading />

  // A reset link has to work regardless of who, if anyone, is signed in on the
  // device the email was opened on.
  if (state !== 'signed_in') {
    return (
      <Routes>
        <Route path="/reset" element={<ResetPassword />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/join" element={<Join />} />
        <Route path="*" element={<Welcome />} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route path="/reset" element={<ResetPassword />} />
      <Route element={<AppShell />}>
        <Route index element={<Today />} />
        <Route path="week" element={<Week />} />
        <Route path="family" element={<Family />} />
        <Route path="plans" element={<Plans />} />
        <Route path="agreement" element={<Agreement />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
